import React from "react";
import ProfileHeader from "./ProfileHeader";
import { Switch, Route } from "react-router-dom";
import { showUser } from "../../../api/users";
import { connect } from "react-redux";
import HV404 from "./../../../404";
import FullPageSpinner from "./../../FullPageSpinner";
import _ from "lodash";
import ProfileBody from "./ProfileBody";
import ProfileBodyMobile from "./ProfileBodyMobile";
import TipJar from "../TipJar";
import { Helmet } from "react-helmet";
import { isMobile } from "react-device-detect";
import ProfilePicture from "../shared/ProfilePicture";
import Login from "../../Onboarding/routes/login";
import Signup from "../../Onboarding/routes/signup";
import About from "../../Onboarding/routes/about";
import { shuffle } from "lodash";
import { latestReleases, removeMediumFromSingle } from "../../../api/sound_tracks";
import hv_player_api from "../../../api/hv_player_api";
import PrimoSubscriptionErrorModal from "../shared/PrimoSubscriptionErrorModal";

class Profile extends React.Component {
  state = { user: null, not_found: false, didUpdateScreen: "", didUpdateVal: false, subscribeErrorModal: false };
  componentDidUpdate(prevProps) {
    if (this.props.match.params.slug !== prevProps.match.params.slug) {
      switch (this.props.match.params.slug) {
        case "login":
          window.location.href = "/login";
          break;
        case "signup":
          window.location.href = "/signup";
          break;
        case "about":
          window.location.href = "/about";
          break;
        default:
          break;
      }
    }
  }
  componentDidMount() {
    this.fetchUser(this.props.match.params.slug);
  }

  setSubscribeErrorModal = () => {
    this.setState({ subscribeErrorModal: false });
  };

  fetchUser = async (paramPass) => {
    try {
      let {
        data: { user },
      } = await showUser(paramPass);
      this.setState({ user });
      this.creditCard();
      if (window.innerWidth <= 768) {
        this.latestReleases();
      }
    } catch (error) {
      this.setState({ not_found: true });
    }
  };

  creditCard = () => {
    if (this.props.location.search.includes("change_card_details")) {
      this.setState({ subscribeErrorModal: true });
    }
  };

  latestReleases = async () => {
    this.setState({ soundtracks: null });
    let {
      data: { soundtracks, meta },
    } = await latestReleases({
      page_number: this.state.page_number,
      page_size: this.state.page_size,
      filter: { user_id: this.state.user.id },
    });
    this.setState({ soundtracks, meta });
    try {
      if (this.state.soundtracks.length) {
        hv_player_api.setQueueMedia({
          type: "Hash",
          current_track_index: 0,
          loaded_media: this.state.soundtracks,
          queue: this.state.soundtracks.map((m) => m.id),
        });
        hv_player_api.setCurrentlyPlayingTrack(this.state.soundtracks[0]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  profile = () => (
    <>
      <ProfileHeader user={this.user()} />
      <ProfileBody user={this.user()} />
      {this.state.subscribeErrorModal && (
        <PrimoSubscriptionErrorModal
          showModal={this.state.subscribeErrorModal}
          setSubscribeErrorModal={this.setSubscribeErrorModal}
          hash={false}
          showDistributingInfo={false}
        />
      )}
    </>
  );
  profileMobile = () => <ProfileBodyMobile user={this.user()} />;

  profileAuto = () => {
    if (!isMobile) {
      return this.profile();
    }
    const { slug } = this.props.match.params;
    if ((slug || "").toLowerCase() === (this.props.current_user?.slug || "").toLowerCase()) {
      return this.profile();
    }
    return this.profileMobile();
  };

  tipJar = () => {
    return <TipJar user={this.user()} />;
  };
  user = () =>
    this.props.current_user && this.props.match.params.username === this.props.current_user.username ? this.props.current_user : this.state.user;

  componentWillUnmount() {
    document.title = "UNIFI MUSIC - For the Fiercely Independent";
  }

  render() {
    return this.state.not_found ? (
      <HV404 />
    ) : _.isNull(this.state.user) ? (
      <FullPageSpinner />
    ) : (
      <div id="profile-page" className="profile d-flex flex-column h-100">
        <Helmet>
          <title>{`${this.state.user.username} on UNIFI MUSIC - For the Fiercely Independent.`}</title>
        </Helmet>
        <Switch>
          <Route path="/:slug/tip-jar" exact render={this.tipJar} />
          <Route path="/:slug" render={this.profileAuto} />
        </Switch>
      </div>
    );
  }
}
export default connect((a) => a)(Profile);
